import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  alertLoading: false,
  alerts: null,
  alertDropdowns: null,
  isAlertCall: false,
};

const alertSlice = createSlice({
  name: "alert",
  initialState,
  reducers: {
    setAlertLoading: (state, action) => {
      state.alertLoading = action.payload;
    },
    setAlerts: (state, action) => {
      state.alerts = action.payload;
    },
    setAlertDropdowns: (state, action) => {
      state.alertDropdowns = action.payload;
    },
    setIsAlertCall: (state, action) => {
      state.isAlertCall = action.payload;
    },
  },
});

export const { setAlertLoading, setAlerts, setAlertDropdowns, setIsAlertCall } =
  alertSlice.actions;
export default alertSlice.reducer;
